// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.push-container[data-v-0a5fc1d4] {\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  overflow:hidden;\n}\n.push-head[data-v-0a5fc1d4] {\n  width: 180px;\n  background:#fafafa;\n  padding: 10px;\n  border-right: 1px solid #ccc;\n}\n", ""]);
// Exports
module.exports = exports;
